"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SpellingEvaluator = void 0;
class SpellingEvaluator {
    async evaluate(submission, activity) {
        const targetWord = String(activity.config.word ?? '').trim().toLowerCase();
        const structured = submission.structuredData;
        const studentWord = String(submission.finalText ??
            structured?.answer ??
            structured?.tapped ??
            '').trim().toLowerCase();
        const isCorrect = studentWord === targetWord;
        const score = isCorrect ? 100 : 0;
        const feedback = isCorrect
            ? `Perfect! "${targetWord}" is spelled correctly.`
            : `Not quite. The correct spelling is "${targetWord}".`;
        return {
            score,
            maxScore: 100,
            isCorrect,
            feedback,
            breakdown: [
                { name: 'Spelling Accuracy', score, maxScore: 100, feedback: isCorrect ? 'Exact match' : 'Misspelled' },
            ],
            skills: [{ key: `spelling:${targetWord}`, label: `Spelling: ${targetWord}` }],
            label: 'Spelling Score',
        };
    }
}
exports.SpellingEvaluator = SpellingEvaluator;
